import moment from 'moment';
import {
  getCars,
  getLogs,
  getFuelTypes,
  getWarranties,
  getCompanyGroups,
  getBreakdownTypes,
} from '../services/dictionary.service';
import { DATE_TIME_FORMAT } from '../../app/config/config';

const LOGS_TABLE_CONFIG = {
  columns: [{
    caption: 'Data',
    dataField: 'createdAt',
    renderCell: (item) => moment(item).format(DATE_TIME_FORMAT),
  },
  {
    caption: 'Opis',
    dataField: 'text',
    sort: true,
  }],
  noItemsFoundText: 'Brak danych',
  initialSort: {
    sortField: 'createdAt',
    sortDirection: 'desc',
  },
  filterFields: 'name',
};

const WARRANTIES_TABLE_CONFIG = {
  columns: [
    {
      caption: 'Nazwa',
      dataField: 'name',
      sort: true,
    },
    {
      caption: 'Czas trwania [msc]',
      dataField: 'duration',
      sort: true,
    },
    {
      caption: 'Limit km',
      dataField: 'mileage_limit',
      sort: true,
    },
    {
      caption: 'Limit wieku',
      dataField: 'year_limit',
      sort: true,
    },
    {
      caption: 'Aktywny',
      dataField: 'active',
      sort: true,
      renderCell: (active) => (active ? 'Tak' : 'Nie'),
    },
  ],
  noItemsFoundText: 'Brak słownika gwarancji',
  initialSort: {
    sortField: 'name',
    sortDirection: 'asc',
  },
  filterFields: 'name',
};

export default {
  logs: {
    title: 'Logi systemowe',
    getItems: getLogs,
    tableConfig: LOGS_TABLE_CONFIG,
  },
  fuels: {
    title: 'Słownik paliw',
    getItems: getFuelTypes,
  },
  manufacturer: {
    canAdd: true,
    title: 'Słownik samochodów',
    getItems: getCars,
    detailsUrl: '/dictionary/manufacturer-details',
    newUrl: '/dictionary/manufacturer',
  },
  companyGroup: {
    canAdd: true,
    title: 'Słownik grup klientów',
    getItems: getCompanyGroups,
    detailsUrl: '/dictionary/company-group',
    newUrl: '/dictionary/company-group',
  },
  warranties: {
    canAdd: true,
    title: 'Słownik gwarancji',
    getItems: getWarranties,
    detailsUrl: '/dictionary/warranty-details',
    newUrl: '/dictionary/warranty',
    tableConfig: WARRANTIES_TABLE_CONFIG,
  },
  breakdownTypes: {
    canAdd: true,
    title: 'Słownik Typów Awarii',
    getItems: getBreakdownTypes,
    detailsUrl: '/dictionary/breakdown-type',
    newUrl: '/dictionary/breakdown-type',
  },
};
